package app.view

import app.CustomRouter
import app.Routes
import app.api.ProjectApi
import app.api.ProjectStepApi
import app.api.ProjectStepApi.StepUpdate
import app.components.*
import app.model.*
import app.svg.chevronDown
import app.svg.chevronUp
import app.svg.delete
import dev.fritz2.core.*
import org.w3c.dom.HTMLInputElement

fun RenderContext.projectStepView(
    projectApi: ProjectApi,
    projectStepApi: ProjectStepApi,
    projectId: String?,
) {
    if (projectId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }
    projectApi.handler(projectId)
    projectStepApi.handler(projectId)

    div("flex gap-4 dark:text-white") {
        sidebarNavigation(projectId)
        projectApi.data.renderNotNull { project ->
            projectStepApi.data.render { steps ->
                div(
                    "basis-10/12 border rounded-md shadow-md my-4 p-4 flex flex-col gap-4" +
                            " dark:bg-gray-800 dark:border-gray-700"
                ) {
                    div("flex justify-between") {
                        select("h-10 w-64 rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                            option {
                                value("")
                                +"Add Step"
                                selected(true)
                            }
                            ProjectStepApi.StepType.entries.forEach { stepType ->
                                option {
                                    value(stepType.name)
                                    +stepType.name
                                }
                            }
                            changes.values() handledBy { typeName ->
                                if (typeName.isNotEmpty()) {
                                    projectStepApi.addStep(ProjectStepApi.StepType.valueOf(typeName))
                                    value("")
                                }
                            }
                        }
                        div("flex gap-2") {
                            projectStepApi.dirtyStore.data.render {
                                buttonText(
                                    text = "Reset",
                                    isDisabled = !it,
                                    onClick = { projectStepApi.handler(projectId) }
                                )
                                buttonText(
                                    text = "Save",
                                    isDisabled = !it,
                                    onClick = { projectStepApi.putProjectStep(projectId) }
                                )

                            }
                        }
                    }
                    steps.forEachIndexed { i, step ->
                        div("border rounded-md bg-gray-300 dark:bg-gray-700 relative p-4 group") {
                            div("absolute top-1 right-1") {
                                div("cursor-pointer") {
                                    chevronUp("size-6")
                                    clicks handledBy {
                                        projectStepApi.updateStepOrdering(
                                            Pair(
                                                step.ordering,
                                                true
                                            )
                                        )
                                    }
                                }
                                div("cursor-pointer") {
                                    chevronDown("size-6")
                                    clicks handledBy {
                                        projectStepApi.updateStepOrdering(
                                            Pair(
                                                step.ordering,
                                                false
                                            )
                                        )
                                    }
                                }
                                div("cursor-pointer group-hover:visible invisible") {
                                    delete("size-5 ml-0.5")
                                    clicks handledBy { projectStepApi.deleteStep(step.ordering) }
                                }
                            }
                            div("flex flex-col gap-2") {
                                projectStepInputText(
                                    label = "Step Name:",
                                    value = step.name,
                                    onChange = {
                                        projectStepApi.updateStep(Pair(i, StepUpdate.Name(it)))
                                    }
                                )
                                executionConditionInput(
                                    stepIndex = i,
                                    stepExecutionCondition = step.executionCondition,
                                    companyProjects = project.companyProjects,
                                    projectStepApi = projectStepApi
                                )
                                runConditionInput(
                                    stepIndex = i,
                                    stepRunCondition = step.runCondition,
                                    projectStepApi = projectStepApi
                                )
                                when (step) {
                                    is EcsDeploymentStep -> {
                                        projectStepInputText(
                                            label = "AWS Region:",
                                            value = step.awsRegion,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.AwsRegion(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "AWS Account:",
                                            value = step.awsAccount,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.AwsAccount(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Cluster Name:",
                                            value = step.clusterName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ClusterName(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Service Name:",
                                            value = step.serviceName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ServiceName(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Task Definition Name:",
                                            value = step.taskDefName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.TaskDefName(it)))
                                            }
                                        )
                                        containerDefinitionsInput(
                                            stepIndex = i,
                                            containerDefinitions = step.containerDefinitions,
                                            projectStepApi = projectStepApi
                                        )
                                    }

                                    is SlackNotificationStep -> {
                                        projectStepInputText(
                                            label = "Webhook URL:",
                                            value = step.webhookUrl,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.WebhookUrl(it))
                                                )
                                            }
                                        )
                                    }

                                    is UpdateLambdaStep -> {
                                        projectStepInputText(
                                            label = "AWS Region:",
                                            value = step.awsRegion,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.AwsRegion(it))
                                                )
                                            }
                                        )
                                        projectStepInputText(
                                            label = "AWS Account:",
                                            value = step.awsAccount,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.AwsAccount(it))
                                                )
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Function Name:",
                                            value = step.functionName,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.FunctionName(it))
                                                )
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Lambda Deployable Name:",
                                            value = step.deployableName,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.DeployableName(it))
                                                )
                                            }
                                        )
                                    }

                                    is InvalidateCloudfrontStep -> {
                                        projectStepInputText(
                                            label = "AWS Account:",
                                            value = step.awsAccount,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.AwsAccount(it))
                                                )
                                            }
                                        )
                                        projectStepInputText(
                                            label = "CNAME Target:",
                                            value = step.cnameTarget,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.CnameTarget(it))
                                                )
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Invalidation Path:",
                                            value = step.invalidationPath,
                                            onChange = {
                                                projectStepApi.updateStep(
                                                    Pair(i, StepUpdate.InvalidationPath(it))
                                                )
                                            }
                                        )
                                        div("flex gap-2") {
                                            p("text-sm") { +"Wait for Invalidation:" }
                                            input("border rounded p-1") {
                                                type("checkbox")
                                                checked(step.waitForInvalidation)
                                                clicks handledBy { event ->
                                                    val isChecked =
                                                        event.target.unsafeCast<HTMLInputElement>().checked
                                                    projectStepApi.updateStep(
                                                        Pair(
                                                            i,
                                                            StepUpdate.WaitForInvalidation(isChecked)
                                                        )
                                                    )
                                                }
                                            }
                                        }
                                    }

                                    is UploadS3Step -> {
                                        projectStepInputText(
                                            label = "AWS Region:",
                                            value = step.awsRegion,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.AwsRegion(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "AWS Account:",
                                            value = step.awsAccount,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.AwsAccount(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Bucket URI:",
                                            value = step.bucketURI,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.BucketURI(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "S3 Deployable Name:",
                                            value = step.deployableName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.DeployableName(it)))
                                            }
                                        )
                                    }

                                    is UpdateDtStep -> {
                                        projectStepInputText(
                                            label = "Project Name:",
                                            value = step.projectName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ProjectName(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "Parent Project UUID (optional, leave empty for root-level DT projects):",
                                            value = step.parentProjectUUID,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ParentProjectUUID(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "API Url:",
                                            value = step.apiUrl,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ApiUrl(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "API Key:",
                                            value = step.apiKey,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ApiKey(it)))
                                            }
                                        )
                                    }

                                    is UpdateDtSbomStep -> {
                                        projectStepInputText(
                                            label = "DT Project Name:",
                                            value = step.projectName,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ProjectName(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "API Url:",
                                            value = step.apiUrl,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ApiUrl(it)))
                                            }
                                        )
                                        projectStepInputText(
                                            label = "API Key:",
                                            value = step.apiKey,
                                            onChange = {
                                                projectStepApi.updateStep(Pair(i, StepUpdate.ApiKey(it)))
                                            }
                                        )
                                    }

                                    is IsEvenStep -> {}
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
